import { render, staticRenderFns } from "./meta.vue?vue&type=template&id=a56bfee2&scoped=true&"
import script from "./meta.vue?vue&type=script&lang=js&"
export * from "./meta.vue?vue&type=script&lang=js&"
import style0 from "./meta.vue?vue&type=style&index=0&id=a56bfee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56bfee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a56bfee2')) {
      api.createRecord('a56bfee2', component.options)
    } else {
      api.reload('a56bfee2', component.options)
    }
    module.hot.accept("./meta.vue?vue&type=template&id=a56bfee2&scoped=true&", function () {
      api.rerender('a56bfee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/meta.vue"
export default component.exports